import { Modules, RouteConstants } from "@valenzinsights/data";
import {
    DocumentWebchat,
    LibraryDocumentViewer,
} from "@valenzinsights/library-module";
import { Error403 } from "@valenzinsights/shared-pages";

import { lazy } from "react";

import { withSuspense } from "../components";

const Healthcare = withSuspense(
	lazy(() =>
		import("@valenzinsights/healthcare-module").then((module) => ({
			default: module.Healthcare,
		})),
	),
);
const Analytics = withSuspense(
	lazy(() =>
		import("@valenzinsights/analytics-module").then((module) => ({
			default: module.Analytics,
		})),
	),
);
const PlanFeature = withSuspense(
	lazy(() =>
		import("@valenzinsights/healthcare-module").then((module) => ({
			default: module.PlanFeature,
		})),
	),
);
const TestResult = withSuspense(
	lazy(() =>
		import("@valenzinsights/healthcare-module").then((module) => ({
			default: module.TestResult,
		})),
	),
);

const Library = withSuspense(
	lazy(() =>
		import("@valenzinsights/library-module").then((module) => ({
			default: module.Library,
		})),
	),
);
const Error401 = withSuspense(
	lazy(() =>
		import("@valenzinsights/shared-pages").then((module) => ({
			default: module.Error401,
		})),
	),
);
const Error404 = withSuspense(
	lazy(() =>
		import("@valenzinsights/shared-pages").then((module) => ({
			default: module.Error404,
		})),
	),
);
const UserManagement = withSuspense(
	lazy(() =>
		import("@valenzinsights/user-management-module").then((module) => ({
			default: module.UserManagementLayout,
		})),
	),
);

const ChatBotDashboard = withSuspense(
	lazy(() =>
		import("@valenzinsights/webchat-module").then((module) => ({
			default: module.ChatBotDashboard,
		})),
	),
);
const HomePage = () => {
	return <ChatBotDashboard />;
};

export const routes = (hasModuleAccess: (module: string) => boolean) => {
	const accessibleRoute = allRoutes.filter((route) => {
		switch (route.path) {
			case RouteConstants.Base:
			case RouteConstants.Home:
				return hasModuleAccess(Modules.Home);
			case RouteConstants.Analytics:
				return hasModuleAccess(Modules.Analytics);
			case RouteConstants.LibraryWorkspace:
			case RouteConstants.PlanFeature:
			case RouteConstants.TestResult:
				return hasModuleAccess(Modules.Library);
			case RouteConstants.MasterData:
				return hasModuleAccess(Modules.MasterData);
			case RouteConstants.UserManagement:
				return hasModuleAccess(Modules.UserManagement);
			default:
				return [
					{
						path: RouteConstants.ErrorUnauthorized,
						element: <Error401 />,
					},
					{
						path: "*",
						element: <Error404 />,
					},
				];
		}
	});

	return accessibleRoute && accessibleRoute.length ? accessibleRoute : allRoutes;
};

export const standaloneRoutes = (
	hasModuleAccess: (module: string) => boolean,
) => {
	const routes = [
		{
			path: RouteConstants.LibraryDocumentView,
			element: <LibraryDocumentViewer />,
			module: Modules.Library,
		},
		{
			path: RouteConstants.LibraryWebchatView,
			element: <DocumentWebchat />,
			module: Modules.Library,
		},
	];

	return routes.filter((route) => hasModuleAccess(route.module));
};

export const allRoutes = [
	{
		path: RouteConstants.Base,
		element: <HomePage />,
	},
	{
		path: RouteConstants.Home,
		element: <HomePage />,
	},
	{
		path: RouteConstants.Analytics,
		element: <Analytics />,
	},
	{
		path: RouteConstants.LibraryWorkspace,
		element: <Library />,
	},
	{
		path: RouteConstants.PlanFeature,
		element: <PlanFeature />,
	},
	{
		path: RouteConstants.TestResult,
		element: <TestResult />,
	},
	{
		path: RouteConstants.MasterData,
		element: <Healthcare />,
	},
	{
		path: RouteConstants.UserManagement,
		element: <UserManagement />,
	},
	{
		path: RouteConstants.ErrorUnauthorized,
		element: <Error401 />,
	},
	{
		path: RouteConstants.ErrorUserNotFound,
		element: <Error403 />,
	},
	{
		path: "*",
		element: <Error404 />,
	},
];
